import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import styles from './form-data-loader.styl'
import { delayRender } from 'helpers/decorators'

const FormDataLoader = ({ logs }) => (
  <div className={cx(styles.wrap, { [styles.logs]: logs })}>
    <div className={styles.loader}>
      <div className={styles.heading} />
      <div className={styles.content}>
        <div className={styles.section}>
          <div className={styles.icon} />
          <div className={styles.line} />
          <div className={styles.paragraph} />
        </div>
        <div className={styles.section}>
          <div className={styles.icon} />
          <div className={styles.line} />
          <div className={styles.paragraph} />
        </div>
        <div className={styles.section}>
          <div className={styles.icon} />
          <div className={styles.line} />
          <div className={styles.paragraph} />
        </div>
        <div className={styles.section}>
          <div className={styles.icon} />
          <div className={styles.line} />
          <div className={styles.paragraph} />
        </div>
      </div>
    </div>
  </div>
)

FormDataLoader.propTypes = {
  logs: PropTypes.bool
}

FormDataLoader.defaultProps = {}

export default delayRender()(FormDataLoader)
